import { Navigate, Outlet, Route, Routes } from 'react-router-dom';

import { useGlobal } from './hooks/useGlobal';
import { GlobalProvider } from './context/GlobalContext';
import { Provider } from './context/clienteContext';
import { CobrancaProvider } from './context/CobrancaContext';

import { SignIn } from './pages/SignIn';
import { SignUp } from './pages/SignUp';
import App from './App';
import ClientePage from './pages/Cliente';
import Home from './pages/Home';
import { Cobranca } from './pages/Cobranca';
import DetalheClientePage from './pages/ClienteDetalhe';
import Page404 from './pages/Page404';

export function CustomRouter() {
  function ProtectedRoutes({ redirectTo }) {
    // @ts-ignore
    const { token } = useGlobal();
    const isAuthenticated = token;

    return isAuthenticated ? <Outlet /> : <Navigate to={redirectTo} />
  };

  return (
    <GlobalProvider>
      <Provider>
        <CobrancaProvider>
          <Routes>
            <Route path='/' >
              <Route path='' element={<SignIn />} />
              <Route path='cadastro' element={<SignUp />} />
              <Route element={<ProtectedRoutes redirectTo='/' />}>
                <Route element={<App />} >
                  <Route path='home' element={<Home />} />
                  <Route path='cliente' element={<ClientePage />} />
                  <Route path='cliente/:id' element={<DetalheClientePage />} />
                  <Route path='cobranca' element={<Cobranca />} />
                </Route>
              </Route>
            </Route>
            <Route path="/404" element={<Page404 />} />
            <Route path="*" element={<Navigate to={"/404"} />} />
          </Routes>
        </CobrancaProvider>
      </Provider>
    </GlobalProvider>
  );
};
